import _ from 'lodash';
import store from '../store';

export * from './admin';
export * from './client';
export * from './contact';
export * from './company';
export * from './project';
export * from './workOrder';
export * from './tagConfig';
export * from './ticket';
export * from './user';
export * from './material';
export * from './vehicle';
export * from './site';
export * from './stripe';
export * from './fmcsa';

const baseApiUrl = process.env.VUE_APP_NODE_ENV === 'production'
    ? `${process.env.VUE_APP_API_URL}/api`
    : '/api';

async function parseApiResponse(res) {
    const isJson = res.headers.get('Content-Type')?.includes('json');
    const body = isJson ? await res.json() : await res.blob();

    const { ok, status, statusText } = res;
    const error = ok ? null : {
        status,
        message: body?.error?.message ?? statusText,
    };

    if (status === 403) {
        store.dispatch('auth/refreshUser');
    }

    return { ok, status, statusText, body, error };
}

export async function request(url, options) {
    const headers = { token: store.state.auth.token };
    if (!headers.token) delete headers.token;

    try {
        const res = await fetch(baseApiUrl + url, _.merge({ headers }, options));
        return parseApiResponse(res);
    } catch (error) {
        console.error('API service error:', error);
        throw error;
    }
}

export async function get(url, options) {
    return request(url, options);
}

export async function post(url, body, options) {
    return request(url, _.merge({
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
    }, options));
}

export async function patch(url, body, options) {
    return request(url, _.merge({
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
    }, options));
}

export async function put(url, body, options) {
    return request(url, _.merge({
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
    }, options));
}

export async function del(url, options) {
    return request(url, _.merge({ method: 'DELETE' }, options));
}

export async function postPhoto(formData, options) {
    return request('/photos', _.merge({ method: 'POST', body: formData }, options));
}